export default __webpack_public_path__ + "static/media/checkImg.c52b8ba4.svg";